import { RPCFactory } from './RequestUtil';
import { useState, useEffect } from 'react';

export const useCheckWhiteList = (accountId, whitelistName) => {
  const [inList, setInList] = useState(false);
  useEffect(() => {
    RPCFactory.account.check_whitelist(accountId, whitelistName).done((data) => {
      if (data) {
        setInList(data);
      }
    });
  }, []);
  return inList;
};
